import { render, staticRenderFns } from "./DemoLockMessage.vue?vue&type=template&id=13a37072"
import script from "./DemoLockMessage.vue?vue&type=script&lang=js"
export * from "./DemoLockMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports